"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDescription = void 0;

var _HelmetHelper = require("./HelmetHelper");

var getDescription = function getDescription(domain, helmetType, data) {
  var agencyDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  var _ref = arguments.length > 5 ? arguments[5] : undefined,
      _ref$alias = _ref.alias,
      alias = _ref$alias === void 0 ? '' : _ref$alias;

  var fd = data.features ? data.features.map(function (f) {
    return _HelmetHelper.FEATURES_LABEL[f];
  }).join(', ') : '';
  var ncommas = fd.split(/,/).length;
  var pos = fd.lastIndexOf(',');
  var featuresDesc = (0, _HelmetHelper.getFeaturesDesc)(data.features, ncommas, fd, pos);
  /**
   * calcoliamo l'eventuale parte della descrizione che riporta il valore del sorting
   */

  var _data$filters = data.filters,
      category = _data$filters.category,
      propertyTypes = _data$filters.propertyTypes,
      roomsRange = _data$filters.roomsRange,
      license_type_groups = _data$filters.license_type_groups,
      sortType = data.sortType;
  var roomsCondition = roomsRange.minimum !== 'any' && roomsRange.minimum === roomsRange.maximum;
  var rooms = roomsCondition ? "".concat((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum), " ") : ' ';
  var isRooms = rooms && rooms.trim().length > 0 && rooms.trim().toLocaleLowerCase() !== 'case';
  var sortValue = "".concat((0, _HelmetHelper.getSortValuePart)(category, propertyTypes, isRooms, sortType, true), " ");
  /**
   * calcoliamo l'eventuale parte della descrizione che riporta il valore del sorting
   */

  var propertyTypesDesc = propertyTypes.length || license_type_groups.length ? (0, _HelmetHelper.getPropertyTypes)(propertyTypes, license_type_groups) : '';
  var isPType = propertyTypesDesc && propertyTypesDesc.trim().length > 0 && propertyTypesDesc.trim().toLocaleLowerCase() !== 'annunci';
  var startDesc = category === 'case' && isRooms ? (0, _HelmetHelper.capitalize)(rooms) : propertyTypesDesc;
  var bcNew = data.filters && data.filters.buildingCondition && _HelmetHelper.BUILDING_CONTITIONS_LABEL[data.filters.buildingCondition] ? "".concat(_HelmetHelper.BUILDING_CONTITIONS_LABEL[data.filters.buildingCondition].toLocaleLowerCase(), " ") : '';
  var isAuctionOrNakedProperty = (0, _HelmetHelper.getAuctionOrNakedProperty)({
    features: data.features,
    propertyTypes: isPType ? startDesc : '',
    sortValue: sortValue,
    bcNew: bcNew,
    isDescription: true
  });
  var withPrefix = true;
  var withZone = true;
  var nearPointOfInterest = '';

  if (data.filters.poi) {
    if (data.filters.poi.subway) {
      nearPointOfInterest = ' vicino alla metro';
    } else if (data.filters.poi.electric_charging) {
      nearPointOfInterest = ' vicino a colonnine ricarica auto elettriche';
    }
  }

  var noResults = count === 0;
  var numResults = noResults ? '' : "".concat((0, _HelmetHelper.getTotalListings)(count), " ");
  var agencyFt = data.agencyFt ? ' corrispondenti alla tua ricerca' : '';
  var lastDescPart = "".concat(nearPointOfInterest, ", trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
  var startResidential = "annunci di case e appartamenti".concat(sortValue, " ");

  var commercialLTG = function commercialLTG(ltg) {
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return ltg.length ? (0, _HelmetHelper.getPropertyTypes)([], license_type_groups) : "attivit\xE0 ".concat(end ? 'o' : 'e', " locali commerciali");
  };

  switch (helmetType) {
    case _HelmetHelper.HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', " a ").concat(agencyDetail.address.suburb, ". Scopri tutti gli annunci di immobili in vendita dell&#039;agenzia ").concat(agencyDetail.name, ". e contatta il tuo agente di fiducia online su ").concat(domain === 'attico' ? 'Attico.it' : 'Casa.it', "!");

    case _HelmetHelper.HELMET_AGENCY_NOT_FOUND_TYPE:
      return 'Agenzia non trovata. Scopri tutti gli annunci di immobili in vendita delle agenzie e contatta il tuo agente di fiducia online su Casa.it!';

    case _HelmetHelper.HELMET_AGENCY_SRP_TYPE:
      return "Casa.it mette a tua disposizione un elenco sempre aggiornato di agenzie immobiliari".concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
        alias: alias
      })).concat(agencyFt, ". Entra e trova l\u2019agenzia pi\xF9 vicina a te");

    case _HelmetHelper.HELMET_SRP_TYPE:
      {
        var channel = data.channel,
            _data$filters2 = data.filters,
            _propertyTypes = _data$filters2.propertyTypes,
            _category = _data$filters2.category,
            _roomsRange = _data$filters2.roomsRange,
            agentCategory = _data$filters2.agentCategory;

        var _rooms = _roomsRange.minimum === 'any' ? ' ' : _category === 'commerciale' ? " con ".concat(_roomsRange.minimum, " locali ") : " ".concat((0, _HelmetHelper.getRoomsRange)(_roomsRange.minimum), " ");

        var sellerType = agentCategory === 'all' ? ' ' : (0, _HelmetHelper.getAgentForDesc)(agentCategory);

        switch (_category) {
          case 'commerciale':
            return "".concat(numResults).concat(noResults ? 'Annunci' : 'annunci', " di ").concat(propertyTypesDesc).concat(_rooms).concat(featuresDesc).concat(bcNew, "in ").concat(channel).concat(sellerType === ' ' ? ', da privati e agenzie immobiliari, ' : sellerType).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            }), ". ").concat(channel === 'vendita' ? 'Acquista' : 'Affitta', " ").concat(propertyTypesDesc.toLowerCase()).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            }), ".");

          case 'vacanze':
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(propertyTypesDesc.toLowerCase()) : propertyTypesDesc.toLowerCase()).concat(_rooms, "per vacanze").concat(featuresDesc).concat(bcNew, " in ").concat(channel).concat(sellerType).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(lastDescPart);

          default:
            return isAuctionOrNakedProperty ? "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(isAuctionOrNakedProperty.text.toLowerCase()) : isAuctionOrNakedProperty.text.toLowerCase()).concat(_rooms).concat(featuresDesc).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(lastDescPart) : "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(propertyTypesDesc.toLowerCase()) : propertyTypesDesc.toLowerCase()).concat(_rooms).concat(sortValue).concat(featuresDesc).concat(bcNew, "in ").concat(channel).concat(sellerType).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(lastDescPart);
        }
      }

    case _HelmetHelper.HELMET_SRP_NO_LOC_TYPE:
      {
        var _channel = data.channel,
            _data$filters3 = data.filters,
            _propertyTypes2 = _data$filters3.propertyTypes,
            _category2 = _data$filters3.category,
            _roomsRange2 = _data$filters3.roomsRange,
            _agentCategory = _data$filters3.agentCategory;

        var _rooms2 = _roomsRange2.minimum === 'any' ? ' ' : _category2 === 'commerciale' ? " con ".concat(_roomsRange2.minimum, " locali ") : " ".concat((0, _HelmetHelper.getRoomsRange)(_roomsRange2.minimum), " ");

        var _sellerType = _agentCategory === 'all' ? '' : (0, _HelmetHelper.getAgentForDesc)(_agentCategory);

        return isAuctionOrNakedProperty ? "".concat((0, _HelmetHelper.capitalize)(isAuctionOrNakedProperty.text.toLowerCase())).concat(_rooms2 !== ' ' ? _rooms2 : '').concat(featuresDesc !== ' ' ? featuresDesc : '').concat(bcNew !== ' ' ? bcNew : '').concat(_sellerType !== ' ' ? _sellerType : '').concat(_category2 === 'vacanze' ? ' per le vacanze' : '', ", ").concat(noResults ? '' : "".concat(numResults, " annunci disponibili, "), "trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '') : "".concat(propertyTypesDesc).concat(_rooms2).concat(sortValue).concat(featuresDesc).concat(bcNew, "in ").concat(_channel).concat(nearPointOfInterest).concat(_sellerType).concat(_category2 === 'vacanze' ? ' per le vacanze' : '', ", ").concat(noResults ? '' : "".concat(numResults, " annunci disponibili, "), "trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
      }

    case _HelmetHelper.HELMET_SRP_NO_PROP_TYPE:
      {
        var _channel2 = data.channel,
            _data$filters4 = data.filters,
            _category3 = _data$filters4.category,
            _roomsRange3 = _data$filters4.roomsRange,
            _agentCategory2 = _data$filters4.agentCategory;
        var moreInfos;
        var SEOTitleStart;

        var _sellerType2 = _agentCategory2 === 'all' ? ' ' : (0, _HelmetHelper.getAgentForDesc)(_agentCategory2);

        if (_category3 === 'vacanze') {
          moreInfos = (0, _HelmetHelper.analyzeLocalities)(data.locations) ? 'annunci di appartamenti e case vacanze ' : 'annunci di case vacanze ';
        } else {
          moreInfos = (0, _HelmetHelper.analyzeLocalities)(data.locations) ? 'annunci di appartamenti e case ' : ' ';
        }

        switch (_category3) {
          case 'commerciale':
            var ltg = commercialLTG(license_type_groups);
            SEOTitleStart = _roomsRange3.minimum === 'any' ? "annunci di ".concat(ltg) : "annunci di ".concat(ltg, " con ").concat(_roomsRange3.minimum, " local").concat(_roomsRange3.minimum === 1 ? 'e' : 'i');
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(SEOTitleStart) : SEOTitleStart, " ").concat(featuresDesc).concat(bcNew, "in ").concat(_channel2).concat(_sellerType2 !== ' ' ? _sellerType2 : ', da privati e agenzie immobiliari, ').concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            }), ". ").concat(_channel2 === 'vendita' ? 'Acquista' : 'Affitta', " ").concat(commercialLTG(license_type_groups, true).toLowerCase()).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '.');

          case 'uffici':
          case 'capannoni':
          case 'edifici-palazzi':
          case 'terreni':
          case 'cantine-solai':
          case 'garage-posti-auto':
          case 'stanze':
            SEOTitleStart = "annunci di ".concat((0, _HelmetHelper.getCategoryDefault)(_category3));
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(SEOTitleStart) : SEOTitleStart, " ").concat(featuresDesc).concat(bcNew, "in ").concat(_channel2).concat(_sellerType2 !== ' ' ? _sellerType2 : ', da privati e agenzie immobiliari, ').concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            }), ". ").concat(_channel2 === 'vendita' ? 'Acquista' : 'Affitta', " ").concat((0, _HelmetHelper.getCategoryDefault)(_category3).toLowerCase()).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '.');

          case 'vacanze':
          case 'case-vacanza':
            moreInfos = _roomsRange3.minimum === 'any' ? 'annunci di appartamenti e case vacanze ' : "".concat((0, _HelmetHelper.getRoomsRange)(_roomsRange3.minimum), " per vacanze ");
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(moreInfos) : moreInfos).concat(featuresDesc).concat(bcNew, "in ").concat(_channel2).concat(_sellerType2).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(lastDescPart);

          default:
            if (isAuctionOrNakedProperty) {
              return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(isAuctionOrNakedProperty.text) : isAuctionOrNakedProperty.text).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
                alias: alias
              })).concat(lastDescPart);
            }

            moreInfos = _roomsRange3.minimum === 'any' ? startResidential : "".concat((0, _HelmetHelper.getRoomsRange)(_roomsRange3.minimum)).concat(sortValue, " ");
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(moreInfos) : moreInfos).concat(featuresDesc).concat(bcNew, "in ").concat(_channel2).concat(_sellerType2).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'desc', withZone)).concat((0, _HelmetHelper.getAliasLocalities)({
              alias: alias
            })).concat(lastDescPart);
        }
      }

    case _HelmetHelper.HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        var _channel3 = data.channel,
            _data$filters5 = data.filters,
            _category4 = _data$filters5.category,
            _roomsRange4 = _data$filters5.roomsRange,
            _agentCategory3 = _data$filters5.agentCategory;

        var _SEOTitleStart;

        var _sellerType3 = _agentCategory3 === 'all' ? ' ' : (0, _HelmetHelper.getAgentForDesc)(_agentCategory3);

        switch (_category4) {
          case 'commerciale':
            var _ltg = commercialLTG(license_type_groups);

            _SEOTitleStart = _roomsRange4.minimum === 'any' ? "annunci di ".concat(_ltg) : "annunci di ".concat(_ltg, " con ").concat(_roomsRange4.minimum, " local").concat(_roomsRange4.minimum === 1 ? 'e' : 'i');
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(_SEOTitleStart) : _SEOTitleStart, " ").concat(featuresDesc).concat(bcNew, "in ").concat(_channel3).concat(_sellerType3 !== ' ' ? _sellerType3 : ', da privati e agenzie immobiliari', ". ").concat(_channel3 === 'vendita' ? 'Acquista' : 'Affitta', " ").concat(commercialLTG(license_type_groups, true).toLowerCase()).concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '.');

          case 'vacanze':
            _SEOTitleStart = _roomsRange4.minimum === 'any' ? 'annunci di case vacanze' : "".concat((0, _HelmetHelper.getRoomsRange)(_roomsRange4.minimum), " per vacanze");
            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(_SEOTitleStart) : _SEOTitleStart).concat(_sellerType3).concat(featuresDesc).concat(bcNew, "in ").concat(_channel3, ", trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

          default:
            _SEOTitleStart = _roomsRange4.minimum === 'any' ? 'annunci di case e appartamenti' : (0, _HelmetHelper.getRoomsRange)(_roomsRange4.minimum);

            if (isAuctionOrNakedProperty) {
              var anText = isAuctionOrNakedProperty.text[isAuctionOrNakedProperty.text.length - 1] === ' ' ? isAuctionOrNakedProperty.text.substring(0, isAuctionOrNakedProperty.text.length - 1) : isAuctionOrNakedProperty.text;
              return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(anText.toLowerCase()) : anText.toLowerCase()).concat(_sellerType3 !== ' ' ? _sellerType3 : '').concat(featuresDesc, ", trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
            }

            return "".concat(numResults).concat(noResults ? (0, _HelmetHelper.capitalize)(_SEOTitleStart) : _SEOTitleStart).concat(sortValue).concat(_sellerType3).concat(featuresDesc).concat(bcNew, "in ").concat(_channel3).concat(nearPointOfInterest, ", trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
        }
      }
  }
};

exports.getDescription = getDescription;